import { findValidFieldId } from "./findValidFieldId";

const key = "add-unknown-trigger";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (validFieldId) => ({
	"Id": 2,
	"Title": "Unknown Trigger",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 4,
		"Code": "EMPTY",
		"Name": "Empty"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Field":
			{
				"Id": validFieldId
			}
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 50,
				"Code": "UNKNOWN-TRIGGER-OPERATOR",
				"Name": "What"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithUnknownTrigger = ruleJson(findValidFieldId(resp.data.Data));
	resp.data.Data.Rules.push(ruleWithUnknownTrigger);
};

export const addUnknownTrigger = [key, applicable, modify];